import {
    whiteColor,
    cardTitle,
    grayColor
} from "./material-dashboard-pro-react.jsx";

import customCheckboxRadioSwitchStyle from "./material-kit-pro-react/customCheckboxRadioSwitchStyle.jsx";
const accountsPageStyle = theme => ({
    ...customCheckboxRadioSwitchStyle,
    main: {
        background: whiteColor
    },
    loadMore: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center"
    },
    cardIconTitle: {
        ...cardTitle,
        marginTop: "15px",
        marginBottom: "0px",
        overflow: "hidden"
    },
    form: {
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: "center",
        "& .MuiFormControl-root": {
            marginRight: "10px !important",
            minWidth: "160px",
            marginTop: "0px !important",
        },
        "& .datePickerFormControl": {
            marginBottom: "5px"
        }
    },
    exportButton: {
        float: "right",
        marginTop: "0px !important"
    },
    addButton :{
        float: "right"
    },
    reactTable: {
        "& .rt-thead .rt-th": {
            fontSize: "14px",
            "&.hd_hide": {
                display: 'none'
            }
        },
        "& .rt-tbody": {
            "& .rt-tr": {
                "&.subscription-incomplete": {
                    color: grayColor[0]
                }
            },
            "& .rt-td": {
                fontSize: "12px",
                padding: "0px 5px",
                "&.td_hide": {
                    display: "none"
                }
            }
        },
        "& .hd_check": {
            "& .MuiIconButton-root": {
                padding: "0px"
            }
        },
    }
});

export default accountsPageStyle;
